<template>
  <div id="SectionCSRD">
    <UIContainer>
      <div class="SectionCSRD__container">
        <div class="SectionCSRD__content">
          <h2 class="SectionCSRD__title">Your CSRD journey starts here</h2>
          <p class="SectionCSRD__description">
            Determining your status is the first step. The Sustainalyse platform
            helps you collect, manage, and report the data needed to be fully
            compliant and audit-ready.
          </p>
        </div>

        <div class="SectionCSRD__cta">
          <UIButton
            size="xl"
            theme="light"
            buttonStyle="outlined"
            class="SectionLeaveSpreadsheet__cta-button"
            :to="{ name: 'Demo' }"
          >
            Request a demo
          </UIButton>
          <UIButton
            size="xl"
            class="SectionLeaveSpreadsheet__cta-button"
            :to="{ name: 'Contact' }"
          >
            Start now
          </UIButton>
        </div>
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import UIButton from '../ui/buttons/UIButton.vue'
import UIContainer from '../ui/containers/UIContainer/UIContainer.vue'
</script>

<style lang="scss" scoped>
#SectionCSRD {
  .SectionCSRD__container {
    background-color: $color-lp-bg-brand-section;
    padding: 2rem;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;

    @include md {
      flex-direction: row;
      align-items: center;
      padding: 4rem;
    }
  }

  .SectionCSRD__content {
    flex: 1;
    text-align: center;

    @include md {
      max-width: 41rem;
      text-align: left;
    }
  }

  .SectionCSRD__title {
    @include font-size-18px();
    color: $color-white;
    font-weight: 600;
    margin-bottom: 1rem;

    @include md {
      @include font-size-36px();
    }
  }

  .SectionCSRD__description {
    @include font-size-16px();
    color: $color-ui-brand-200;

    @include md {
      @include font-size-20px();
    }
  }

  .SectionCSRD__cta {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex-shrink: 0;
    align-items: center;
    width: 100%;

    @include md {
      flex-direction: row;
      width: auto;
      gap: 1.25rem;
    }
  }

  .SectionCSRD__cta-button {
    white-space: nowrap;
    width: 100%;

    @include md {
      width: auto;
    }
  }
}
</style>
